import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as MessageIncomingService from '../../../services/api/message_incoming';
import * as RequestInformation from '../../../services/api/info_request';

interface IFetchMessageIncomingListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  originatingCountry?: string;
  messageType?: string;
  status?: string | null | undefined;
  date_from?: Date | null | undefined;
  date_to?: Date | null | undefined;
}

class FetchMessageIncomingList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_MESSAGE_INCOMING_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_MESSAGE_INCOMING_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_MESSAGE_INCOMING_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IFetchMessageIncomingListInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await MessageIncomingService.fetchMessageIncoming(
          payload
        );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchMessageIncomingList Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchMemberStateExcludeCyprus implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RequestInformation.getCountriesMemberState(true);
        // console.log(response.data);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchMemberStateExcludeCyprus Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface IFetchMessageIncomingXmlInput {
  messageId: string;
}

class FetchMessageIncomingXml implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.GET_MESSAGE_INCOMING_XML,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.GET_MESSAGE_INCOMING_XML,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.GET_MESSAGE_INCOMING_XML,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IFetchMessageIncomingXmlInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await MessageIncomingService.fetchMessageIncomingXml(
          payload
        );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchMessageIncomingXml Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  fetchMessageIncomingAction: (payload: IFetchMessageIncomingListInput) =>
    new FetchMessageIncomingList().action(payload),
  fetchMemberStateExcludeCyprusAction: () =>
    new FetchMemberStateExcludeCyprus().action(),
  fetchMessageIncomingXmlAction: (payload: IFetchMessageIncomingXmlInput) =>
    new FetchMessageIncomingXml().action(payload),
};
